import { create } from 'zustand';
import { AuthState, User, LoginRequest } from '../types';
import { authApi } from '../services/api';

interface AuthActions {
  login: (credentials: LoginRequest) => Promise<void>;
  logout: () => void;
  setUser: (user: User | null) => void;
  setToken: (token: string | null) => void;
  initialize: () => Promise<void>;
}

export const useAuthStore = create<AuthState & AuthActions>((set, get) => ({
  user: null,
  token: null,
  isAuthenticated: false,

  setUser: (user) => 
    set({ user, isAuthenticated: !!user }),

  setToken: (token) => {
    if (token) {
      localStorage.setItem('token', token);
    } else {
      localStorage.removeItem('token');
    }
    set({ token });
  },

  login: async (credentials) => {
    try {
      const response = await authApi.login(credentials);
      const { token, user } = response.data;
      
      get().setToken(token);
      get().setUser(user);
    } catch (error) {
      throw error;
    }
  },

  logout: () => {
    get().setToken(null);
    get().setUser(null);
    authApi.logout().catch(() => {});
  },

  initialize: async () => {
    const token = localStorage.getItem('token');
    if (!token) return;

    try {
      set({ token });
      const response = await authApi.getMe();
      get().setUser(response.data.user);
    } catch (_error) {
      get().setToken(null);
      get().setUser(null);
    }
  },
}));